(function () {
    var toggle = document.getElementById('menu-toggle');
    var closeBtn = document.getElementById('menu-close');
    var navContainer = document.getElementById('header-nav-container');

    if (!toggle || !navContainer) {
        return;
    }

    function openNav() {
        navContainer.classList.add('nav-open');
        document.body.classList.add('nav-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (closeBtn) {
            closeBtn.focus();
        }
    }

    function closeNav() {
        navContainer.classList.remove('nav-open');
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
    }

    toggle.addEventListener('click', function () {
        if (navContainer.classList.contains('nav-open')) {
            closeNav();
        } else {
            openNav();
        }
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', closeNav);
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && navContainer.classList.contains('nav-open')) {
            closeNav();
        }
    });

    // Auto-close when viewport grows past the mobile breakpoint
    var mq = window.matchMedia('(min-width: 992px)');
    mq.addEventListener('change', function (e) {
        if (e.matches && navContainer.classList.contains('nav-open')) {
            closeNav();
        }
    });
}());
